import { useTranslation, LoadMessages as LoadMessagesType, Translation as TranslationType } from './locale.hooks';

/* istanbul ignore next */
if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/dist/locale-data/en'); // Add locale data for en
}

/* istanbul ignore next */
if (!(Intl as { RelativeTimeFormat?: unknown }).RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/en'); // Add locale data for en
}

type Translation = TranslationType;
type LoadMessages = LoadMessagesType;

export { Translation, LoadMessages };
export { LocaleContext } from './locale-context';
export { defaultLocale } from './constants';
export { LanguageProvider } from './LanguageProvider';
export { prepareDateForTranslation } from './date-utils';
export { useTranslation };
